module.exports = __webpack_public_path__ + "img/template-demo-3.cb309a9c.jpg";